import { render, staticRenderFns } from "./ToggleExpand.global.vue?vue&type=template&id=465de1fe&scoped=true&lang=pug&"
import script from "./ToggleExpand.global.vue?vue&type=script&lang=ts&"
export * from "./ToggleExpand.global.vue?vue&type=script&lang=ts&"
import style0 from "./ToggleExpand.global.vue?vue&type=style&index=0&id=465de1fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465de1fe",
  null
  
)

export default component.exports